var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8055 14.0415H25V14H16V18H21.6515C20.827 20.3285 18.6115 22 16 22C12.6865 22 10 19.3135 10 16C10 12.6865 12.6865 10 16 10C17.5295 10 18.921 10.577 19.9805 11.5195L22.809 8.691C21.023 7.0265 18.634 6 16 6C10.4775 6 6 10.4775 6 16C6 21.5225 10.4775 26 16 26C21.5225 26 26 21.5225 26 16C26 15.3295 25.931 14.675 25.8055 14.0415Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15283 11.3455L10.4383 13.755C11.3273 11.554 13.4803 10 15.9998 10C17.5293 10 18.9208 10.577 19.9803 11.5195L22.8088 8.691C21.0228 7.0265 18.6338 6 15.9998 6C12.1588 6 8.82783 8.1685 7.15283 11.3455Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 26C18.5832 26 20.9302 25.0115 22.7047 23.404L19.6097 20.785C18.5719 21.5742 17.3039 22.001 16.0002 22C13.3992 22 11.1907 20.3415 10.3587 18.027L7.09766 20.5395C8.75266 23.778 12.1137 26 16.0002 26Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8055 14.0415H25V14H16V18H21.6515C21.2571 19.1082 20.5467 20.0766 19.608 20.7855L19.6095 20.7845L22.7045 23.4035C22.4855 23.6025 26 21 26 16C26 15.3295 25.931 14.675 25.8055 14.0415Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayIcon);
export default __webpack_public_path__ + "static/media/google-play-icon.eaa2ff6534b3312272ed7513947db318.svg";
export { ForwardRef as ReactComponent };